import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import classNames from 'classnames';
var ITEM_HEIGHT = 36;
var PICKER_ITEM_ICON_WIDTH = 24;
export default function PickerItem(_ref) {
  var index = _ref.index,
      isSelected = _ref.isSelected,
      renderIcon = _ref.renderIcon,
      renderTitle = _ref.renderTitle,
      renderSubtitle = _ref.renderSubtitle,
      props = _objectWithoutProperties(_ref, ["index", "isSelected", "renderIcon", "renderTitle", "renderSubtitle"]);

  return React.createElement("div", Object.assign({
    "data-mention-picker-item-index": index,
    style: {
      height: ITEM_HEIGHT
    },
    className: classNames(['mention-picker-item', 'margin-smaller radius-normal', 'flexbox flexbox-align-center', 'font-size-normal', 'padding-small no-outline pointer line-height-small', 'shade-05'], {
      'background-shade-50': isSelected
    })
  }, props), React.createElement("div", {
    className: "padding-right-small mention-picker-item-icon"
  }, renderIcon({
    width: PICKER_ITEM_ICON_WIDTH
  })), React.createElement("div", {
    className: "mention-picker-item-title nowrap line-height-normal font-weight-medium padding-right-small overflow-hidden"
  }, renderTitle()), React.createElement("div", {
    className: "mention-picker-item-subtitle shade-20 ellipsis line-height-normal font-size-smaller padding-right-small"
  }, renderSubtitle()));
}